import React from "react";
import Select from "react-select";
import { Button, Toast } from "react-bootstrap";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import Waterfall from "components/Waterfall/Waterfall";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

//RunTile copy imports
import { InfoItem } from "components/Home/Utils/Utils";
import getStyles from "components/Home/Utils/getStyles";
import { faBullseye, faDatabase } from "@fortawesome/free-solid-svg-icons";

export default class Setup extends React.PureComponent {
  renderMini(waterfallBars, setup) {
    const runStyles = getStyles("run");
    return (
      <div className={styles.tileWrapper + " " + styles.miniTileWrapper}>
        <div className={styles.miniTile + styles.miniModelGroup}>
          <div className={styles.tileHeader + " " + runStyles.background + " " + styles.miniTileHeader}>
            <div className={styles.labelWrapper}>
              <h1 title="Label" className={styles.headerSetup + " " + runStyles.text}>
                {setup.label}
              </h1>
            </div>
            <div className={styles.waterfallOuter}>
              <Waterfall
                // className={styles.waterfall}
                bars={waterfallBars}
                totalLabel={setup.netImpactLabel}
                roundTotal
                showTotalVal
              />
            </div>
          </div>
          <div className={styles.tileBody + " " + styles.miniTileBody} style={{ height: "40px" }}>
            <React.Fragment>
              <InfoItem
                icon={<FontAwesomeIcon icon={faDatabase} />}
                text={"Process Capacity: " + setup.processLimit}
                hideMobile
              />
            </React.Fragment>
          </div>
        </div>
      </div>
    );
  }

  renderSetupItem(label, impact, count) {
    const { setup, blueprint, hasHighlight, isSmall } = this.props;

    const blueprintSetup = blueprint && blueprint.wizard && blueprint.wizard.setup ? blueprint.wizard.setup : undefined;

    return (
      <div className={styles.setupDetails}>
        <div
          className={
            styles.inputValueLabel +
            " " +
            (hasHighlight
              ? blueprintSetup && blueprintSetup[label] === setup[label]
                ? styles.blueprintSelected
                : styles.userSelected
              : "")
          }
        >
          {setup[label]}
        </div>
        <div
          className={
            styles.inputValueNumber +
            " " +
            (hasHighlight
              ? blueprintSetup && blueprintSetup[impact] === setup[impact]
                ? styles.blueprintSelected
                : styles.userSelected
              : "")
          }
        >
          {setup[impact]}
        </div>
        <div
          className={
            styles.inputValueNumber +
            " " +
            (hasHighlight
              ? blueprintSetup && blueprintSetup[count] === setup[count]
                ? styles.blueprintSelected
                : styles.userSelected
              : "")
          }
        >
          {setup[count]}
        </div>
      </div>
    );
  }

  render() {
    const { setup, blueprint, hasHighlight, isSmall } = this.props;

    const waterfallBars = setup.hideCosts
      ? [
          {
            label: setup.truePositiveLabel,
            value: Number(setup.conversionGain) * setup.truePositive
          },
          {
            label: setup.falsePositiveLabel,
            value: Number(setup.conversionCost) * setup.falsePositive
          }
        ]
      : [
          {
            label: setup.truePositiveLabel,
            value: Number(setup.conversionGain) * setup.truePositive
          },
          {
            label: setup.falsePositiveLabel,
            value: Number(setup.conversionCost) * setup.falsePositive
          },
          {
            label: setup.trueNegativeLabel,
            value: Number(setup.conversionSaved) * setup.trueNegative
          },
          {
            label: setup.falseNegativeLabel,
            value: Number(setup.conversionMissed) * setup.falseNegative
          }
        ];

    return isSmall ? (
      <div className={styles.smallSetup}>
        {this.renderMini(waterfallBars, setup)}
        {/* <div className={styles.smallLabels}>
					<div className={styles.setupLabel}>{setup.truePositiveLabel}</div>
					<div className={styles.setupLabel}>{setup.falsePositiveLabel}</div>
					<div className={styles.setupLabel}>{setup.trueNegativeLabel}</div>
					<div className={styles.setupLabel}>{setup.falseNegativeLabel}</div>
					<div className={styles.setupLabel}>{setup.netImpactLabel}</div>
				</div>
				<Waterfall className={runStyles.background} bars={waterfallBars} totalLabel={setup.netImpactLabel} roundTotal showTotalVal /> */}
      </div>
    ) : (
      <div className={styles.setup}>
        <div className={styles.sFlex}>
          <div className={styles.labels}>
            <div className={styles.detailsFlex + " " + styles.setupHeader}>
              <div className={styles.inputLabel}>{"Label"}</div>
              <div className={styles.inputNumber}>{"Impact"}</div>
              <div className={styles.inputNumber}>{"Count"}</div>
            </div>
            {this.renderSetupItem("truePositiveLabel", "conversionGain", "truePositive")}
            {this.renderSetupItem("falsePositiveLabel", "conversionCost", "falsePositive")}
            {this.renderSetupItem("trueNegativeLabel", "conversionSaved", "trueNegative")}
            {this.renderSetupItem("falseNegativeLabel", "conversionMissed", "falseNegative")}
          </div>
          <Waterfall
            className={styles.waterfallHolder}
            bars={waterfallBars}
            totalLabel={setup.netImpactLabel}
            roundTotal
            showTotalVal
          />
        </div>
        <div className={styles.setupBottom + " " + styles.sProcess}>
          <div className={styles.rightDetails}>
            <div className={styles.inputLabel}>{"Process Capacity:"}</div>
            <div className={styles.inputNumber}>{setup.processLimit}</div>
          </div>
        </div>
      </div>
    );
  }
}
